class ReportsDelegate {
    setRows(rows, type) {
        if (type === 'users') {
            this.setState({ usersRows: rows });
        } else if (type === 'transactions') {
            this.setState({ transactionsRows: rows });
        }
    }

    async handleTimeFrameChange(timeFrame) {
        const { filters } = this.state;
        this.setState({ filters: { ...filters, timeFrame } });
    }

    async handleDateRangeChange(dateRange) {
        const { filters } = this.state;
        this.setState({ filters: { ...filters, dateRange } });
    }

    async handleFilterChange(name, value) {
        const { filters } = this.state;
        this.setState({ filters: { ...filters, [name]: value } });
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }
}

export default ReportsDelegate;

